
import { createApiMethod, createSocketMethod } from '../lib/apiController'

/** method list */
export default {
  searchTransProducts: createSocketMethod('/admin/service/transpayment/search'),
  addTransProduct: createSocketMethod('/admin/service/transpayment/add'),
  getSigueAgencyInfo: createSocketMethod('/admin/service/sigue/agent_info'),
  alltrustLocations: createSocketMethod('/admin/service/alltrust/locations'),
  alltrustAdminApi: createSocketMethod('/admin/service/alltrust/api'),
  getServerLogs:  createSocketMethod('/admin/service/logs/get'),
}



// WEBPACK FOOTER //
// ./src/templates/scopeActions.js